import { useCallback, useEffect, useMemo, useState } from 'react';
import { addYears, differenceInMonths, format, isEqual, startOfMonth } from 'date-fns';
function toISODate(date) {
    return format(date, 'yyyy-MM-dd');
}
function getSelectedMonth(value, allowEmptyValue) {
    if (value) {
        return startOfMonth(new Date(value));
    }
    if (allowEmptyValue) {
        return undefined;
    }
    return startOfMonth(new Date());
}
export function useSelectMonth({ value, select, close, isMonthDisabled, allowEmptyValue = false, }) {
    const [selectedMonth, setSelectedMonth] = useState(() => getSelectedMonth(value, allowEmptyValue));
    const [showedMonths, setShowedMonths] = useState(() => {
        return startOfMonth(value ? new Date(value) : new Date());
    });
    const today = startOfMonth(new Date());
    useEffect(() => {
        const nextSelectedMonth = getSelectedMonth(value, allowEmptyValue);
        setSelectedMonth(nextSelectedMonth);
        if (nextSelectedMonth) {
            setShowedMonths(nextSelectedMonth);
        }
    }, [allowEmptyValue, value]);
    const months = useMemo(() => {
        const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        return months.map(month => {
            const dateOfMonth = new Date(showedMonths.getFullYear(), month, 1);
            const iso = toISODate(dateOfMonth);
            const isSelected = selectedMonth ? isEqual(dateOfMonth, selectedMonth) : false;
            const isDisabled = isMonthDisabled
                ? isMonthDisabled(dateOfMonth)
                : Math.abs(differenceInMonths(dateOfMonth, today)) > 3;
            return {
                iso,
                date: dateOfMonth,
                isDisabled,
                isSelected,
            };
        });
    }, [isMonthDisabled, today, showedMonths, selectedMonth]);
    const goToPrevYear = () => {
        setShowedMonths(addYears(showedMonths, -1));
    };
    const goToNextYear = () => {
        setShowedMonths(addYears(showedMonths, 1));
    };
    const onMonthClick = useCallback((date) => {
        if (selectedMonth && isEqual(selectedMonth, date)) {
            setSelectedMonth(undefined);
            select(undefined);
        }
        else {
            setSelectedMonth(date);
            select(date);
            if (close)
                close();
        }
    }, [close, select, selectedMonth]);
    return {
        selectedMonth,
        showedMonths,
        months,
        goToPrevYear,
        goToNextYear,
        onMonthClick,
    };
}
